var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('setting-manager',{attrs:{"type":"task-setting"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }